import { FC, Key } from 'react';
import { Flex, Tree } from 'antd';
import {
  ErrorMessage,
  SLabelTitle,
  ModalDialog,
  SDropdown,
  SInput,
} from '../../';
import { IProps } from './type';
import styles from './index.module.scss';
import { modalTypes } from '../../../assets/enums';
import globalStyles from '../../../assets/styles/index.module.scss';
import { useAppSelector } from '../../../store';

const ProfileModal: FC<IProps> = (props) => {
  const { getFieldProps, setFieldValue, values, errors, touched } =
    props.formik;

  const { organization } = useAppSelector(
    (state) => state.userReducer.userInfo,
  );

  return (
    <ModalDialog
      title={props.title}
      subTitle={props.subTitle}
      open={props.open}
      handleOk={props.handleSubmit}
      handleCancel={props.handleCancel}
    >
      <Flex gap="middle" vertical>
        {props.type === modalTypes.CREATE && (
          <Flex align="flex-start" justify="space-between">
            <SLabelTitle>Şirket Bilgileri</SLabelTitle>
            <SDropdown
              id="organization"
              value={
                props.organizations.find(
                  (item) =>
                    item.id ===
                    (values.organization ||
                      (organization !== 1 ? organization : undefined)),
                )?.name
              }
              placeholder="Şirket Seçiniz"
              className={globalStyles.width200px}
              disabled={organization !== 1}
              options={props.organizations.map((item) => ({
                value: item.id,
                label: item.name,
              }))}
              onChange={(value) => setFieldValue('organization', value)}
            />
            {touched.organization && errors.organization && (
              <ErrorMessage>{errors.organization}</ErrorMessage>
            )}
          </Flex>
        )}
        <Flex gap="small" vertical>
          <SLabelTitle>Profil Bilgileri</SLabelTitle>
          <Flex vertical gap="small">
            <SInput placeholder="Profil Adı" {...getFieldProps('name')} />
            {touched.name && errors.name && (
              <ErrorMessage>{errors.name}</ErrorMessage>
            )}
          </Flex>
        </Flex>
        <Flex gap="small" vertical>
          <SLabelTitle>Yetki Alanları</SLabelTitle>
          <Flex justify="space-around">
            <Tree
              checkable
              defaultExpandAll
              treeData={props.permissionTree?.left}
              className={styles.customCheckbox}
              onCheck={(
                checkedKeysValue:
                  | {
                      checked: Key[];
                      halfChecked: Key[];
                    }
                  | Key[],
              ) => setFieldValue('leftPermissions', checkedKeysValue)}
              checkedKeys={values.leftPermissions}
            />
            <Tree
              checkable
              defaultExpandAll
              treeData={props.permissionTree?.right}
              className={styles.customCheckbox}
              onCheck={(
                checkedKeysValue:
                  | {
                      checked: Key[];
                      halfChecked: Key[];
                    }
                  | Key[],
              ) => setFieldValue('rightPermissions', checkedKeysValue)}
              checkedKeys={values.rightPermissions}
            />
          </Flex>
        </Flex>
      </Flex>
    </ModalDialog>
  );
};

export default ProfileModal;
